export enum ActionType {
  ROUTER_NAVIGATION = 'ROUTER_NAVIGATION',
  HTTP_REQUEST = 'HTTP_REQUEST',
  LOGS_SENT = 'LOGS_SENT',
}

export interface ActionHistory {
  actionType: ActionType;
  navigationUrl?: string;
  httpRequest?: {
    method: string;
    url: string;
  };
}
